// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f-render-comp-searcher{padding:0 10px}.f-render-comps{padding:0;margin-top:10px}.f-render-comps .f-render-comp{width:115px;line-height:1.5em;color:#606266;border:1px solid #ebeef5;overflow:hidden;cursor:move;white-space:nowrap;display:inline-block;text-overflow:ellipsis;border-radius:3px;padding:6px 8px;box-sizing:border-box;margin:5px;font-size:12px}.f-render-comps .f-render-comp-title{font-weight:700;color:#222}", ""]);
// Exports
module.exports = exports;
